import React, { useState } from "react";
import { BTN_BLACK, INPUT } from "@/components/pageSettings/AdminModal";

export const SCOPES = [["default", "Only pages using the default design"], ["all", "Every page (overrides designs picked for a page)"]];
export const ON_WINNER = [["auto", "Switch automatically and tell me"], ["approve", "Ask me to approve the switch first"]];
export const MIN_VIEWS = [[100, "100 views each"], [200, "200 views each"]];

export function Choice({ label, value, options, onChange, testId, disabled }) {
  return (
    <label className="block">
      <span className="label-mono">{label}</span>
      <select className={INPUT} value={value} disabled={disabled} data-testid={testId}
        onChange={(e) => onChange(typeof options[0][0] === "number" ? Number(e.target.value) : e.target.value)}>
        {options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
      </select>
    </label>
  );
}

export function ThankYouTestSetup({ available, busy, onStart, buyer = false, own = false, p = "ty-test" }) {
  const [picked, setPicked] = useState([]);
  const [minViews, setMinViews] = useState(100);
  const [scope, setScope] = useState("default");
  const [onWinner, setOnWinner] = useState("auto");
  const toggle = (k) => setPicked((x) => (x.includes(k) ? x.filter((y) => y !== k) : x.length >= 4 ? x : [...x, k]));
  const start = () => onStart({ designs: picked, min_views: minViews, on_winner: onWinner, ...(buyer ? {} : { scope }) });
  return (
    <div className="space-y-3" data-testid={`${p}-setup`}>
      <p className="text-[12px] text-zinc-600">
        Pick 2–4 designs. Each visitor {buyer ? "to these pages " : ""}sees one of them (always the same one) until every design has enough views,
        then the one with the best tap rate wins{own ? " and becomes your thank-you page" : buyer ? " and becomes this buyer's thank-you page" : ""}.
      </p>
      <div className="flex flex-wrap gap-2">
        {(available || []).map((d) => (
          <label key={d.key} className={`flex cursor-pointer items-center gap-2 border-2 border-black px-2 py-1 text-sm ${picked.includes(d.key) ? "bg-black text-white" : "bg-white"}`}
            data-testid={`${p}-pick-${d.key}`}>
            <input type="checkbox" className="accent-emerald-600" checked={picked.includes(d.key)} onChange={() => toggle(d.key)} />
            {d.name}
          </label>
        ))}
      </div>
      <div className={`grid gap-3 ${buyer ? "md:grid-cols-2" : "md:grid-cols-3"}`}>
        <Choice label="Pick a winner after" value={minViews} options={MIN_VIEWS} onChange={setMinViews} testId={`${p}-min-views`} />
        {!buyer && <Choice label="Pages in the test" value={scope} options={SCOPES} onChange={setScope} testId={`${p}-scope`} />}
        <Choice label="When a winner is found" value={onWinner} options={ON_WINNER} onChange={setOnWinner} testId={`${p}-on-winner`} />
      </div>
      <button type="button" className={BTN_BLACK} disabled={busy || picked.length < 2} data-testid={`${p}-start`} onClick={start}>
        Start test
      </button>
    </div>
  );
}
